import React from 'react';
import { useLocation } from 'react-router-dom';
import DashboardOverview from './DashboardOverview';
import DashboardTrends from './DashboardTrends';
import DashboardTestAutomation from './DashboardTestAutomation';

const isOverviewPath = (pathname: string) => pathname === '/automation-flows/dashboard/overview';
const isTrendsPath = (pathname: string) => pathname === '/automation-flows/dashboard/trends';
const isTestAutomationPath = (pathname: string) => pathname === '/automation-flows/dashboard/test-automation';

const DashboardPage: React.FC = () => {
  const location = useLocation();
  const pathname = location.pathname;

  if (isOverviewPath(pathname)) {
    return <DashboardOverview />;
  }
  if (isTrendsPath(pathname)) {
    return <DashboardTrends />;
  }
  if (isTestAutomationPath(pathname)) {
    return <DashboardTestAutomation />;
  }

  return <DashboardOverview />;
};

export default DashboardPage;
